import { useState, useEffect } from 'react';

export function CountdownTimer({ expiresAt, className = '' }) {
  const [timeLeft, setTimeLeft] = useState('');
  const [isExpired, setIsExpired] = useState(false);
  
  useEffect(() => {
    const updateCountdown = () => {
      const now = new Date();
      const expires = new Date(expiresAt);
      const diff = expires - now;
      
      if (diff <= 0) {
        setIsExpired(true);
        setTimeLeft('Expired');
        return;
      }
      
      const minutes = Math.floor(diff / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);
      setTimeLeft(`${minutes}m ${seconds.toString().padStart(2, '0')}s`);
    };
    
    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, [expiresAt]);
  
  if (!expiresAt) return null;
  
  return (
    <span className={`${isExpired ? 'text-coral' : 'text-pending-pay'} ${className}`}>
      {isExpired ? 'Hold expired' : `Expires in ${timeLeft}`}
    </span>
  );
}
